
import './filterInput.css';
import React from 'react'

function FilterInput({placeholder, setItem}) {

    const changeHandler = (e) => {
        let inputValue = e.target.value;
        if (inputValue.trim() != "") {
            e.target.classList.add('has-value');
        } else {
            e.target.classList.remove('has-value');
        }
        setItem(inputValue.trim());
    }
    return (
        <div className="filter-input">
            <input type="text" onChange={(e)=>changeHandler(e)} />
            <label>{placeholder}</label>
        </div>
    )
}

export default FilterInput
